import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BtnCellRendererComments } from 'src/app/core/grid/btn-cell-render-comments.component';

import { MatDialog } from '@angular/material/dialog';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { RouteCommentsComponent } from 'src/app/core/dialogs/route-comments/route-comments.component';
import { GridSingleviewLinkComponent } from 'src/app/core/grid/grid-singleview-link.component';
import { GridDataService } from 'src/app/service/grid-data.service';
import { GroupIDetailLevelService } from 'src/app/service/group-i/detail-level.service';
import { GroupiRouteService } from 'src/app/service/group-i/route-level.service';
import { RowCheckboxComponent } from '../../../core/grid/row-checkbox.component';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { GroupiTierService } from 'src/app/service/group-i/tier-level';

@Component({
  selector: 'app-groupiroute',
  templateUrl: './groupiroute.component.html',
  styleUrls: ['./groupiroute.component.scss'],
  standalone: false
})
export class GroupirouteComponent implements OnInit {
  isAccessible = false;
  isStatus: any;
  selected_position_id: any;
  roundItems: any;
  selected_period_id: string;

  constructor(private readonly location: Location, public groupirouteService: GroupiRouteService, private readonly constants: Constants, public groupitierService: GroupiTierService,
    private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly router: Router, private readonly groupIDetailLevelService: GroupIDetailLevelService,
    private readonly gridDataService: GridDataService, public dialog: MatDialog, private readonly groupIStateService : GroupIStateService,) {

    this.context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true,
      filterParams: {
        newRowsAction: 'keep'
      }
    }
    const GroupI_WidgetsData = localStorage.getItem('GroupI_WidgetsData');
    if (GroupI_WidgetsData) {
      this.GroupI_WidgetsData = JSON.parse(GroupI_WidgetsData);
    }
  }
  defaultColDef;
  @ViewChild('agGrid', { static: true }) agGrid;
  rowData;
  gridApi: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  kpiId;
  rowCount = 0;
  tierTitle
  context: any;
  gridOptions;
  alarmID;
  status;
  compOrReArr = [];
  successMessage
  errorMessage
  isChecked: boolean = false;
  PeriodLabel: string;
  columnDefs = [
    {
      headerName: '',
      field: 'rowCheckBox',
      minWidth: 40,
      cellRenderer: RowCheckboxComponent,
    },
    {
      headerName: "Alarm", field: "alarm", autoHeight: true, minWidth: 450, cellClass: "left_align",
      cellRenderer: GridSingleviewLinkComponent,
      cellRendererParams: { column: 'Alarm' }
    },
    {
      headerName: "Issues", field: "issues", autoHeight: true
    },
    {
      headerName: "Ignored", field: "ignored", autoHeight: true
    },
    {
      headerName: "Complete", field: "completed", autoHeight: true
    },
    {
      headerName: "Remaining", field: "remaining", autoHeight: true
    }
    ,
    {
      headerName: "Comments", headerClass: "comments", field: "route_comments",
      cellRenderer: BtnCellRendererComments,

    }
  ];
  GroupI_WidgetsData = {
    id_TierPosition: null,
    id_Round: null,
    id_KPI: null,
    id_Alarm: null,
    alarm_type_id: null,
    title_Tier: null,
    title_Route: null,
    isCompleted: 0,
    isVerified: 0,
    isRoutes: 0,
    isAssigned: 0,
    assigneeId: null
  }
  shouldHide: boolean = false;

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.selected_period_id = localStorage.getItem("selectedPeriodId");
    const data = JSON.parse(localStorage.getItem('gird'));
    this.selected_position_id = this.GroupI_WidgetsData.id_TierPosition;
    this.groupitierService.onTierChangeGetRounds(this.selected_period_id, Number(this.selected_position_id)).subscribe(result => {
      this.roundItems = result;
      this.isStatus = data?.find(x => x.tierPosition == this.selected_position_id)?.RoundStatus  // NOSONAR
      let userID
      const userData = sessionStorage?.getItem('FGA');
      if (userData) {
        userID = JSON.parse(userData)?.user?.userPrincipalName;
      }

      if (!(this.isStatus == "CLOSED" || this.GroupI_WidgetsData.isAssigned == 0 || this.GroupI_WidgetsData.assigneeId != userID || this.roundItems[this.roundItems?.length - 1] != this.GroupI_WidgetsData.id_Round)) // NOSONAR
       { this.shouldHide = true; }
    });

    this.PeriodLabel = localStorage.getItem('selectedPeriodValue')
    this.tierTitle = this.GroupI_WidgetsData.title_Tier
    this.gridOptions = this.gridDataService.getGridOptions();
    this.loadData();
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   if (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin))
    //     this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }


  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }


  loadData() {

    this.ngxUiLoaderService.start(this.constants.LoaderComponent);
    this.kpiId = Number(this.GroupI_WidgetsData.id_KPI) >= 0 ? Number(this.GroupI_WidgetsData.id_KPI) : 0;
    this.groupirouteService.getRouteData(this.kpiId).subscribe(
      result => {
        const model = this.gridApi?.getFilterModel();
        this.rowData = result;
        this.rowCount = this.rowData.length;
        this.gridApi?.setFilterModel(model);
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      }, _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      });

  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") // NOSONAR
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(this.rowData.length))
    }
    else
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value))
    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage()  }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) { // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) { // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }

  routeComments(data, pagename) {
    if (pagename == 'route_comments') {  // NOSONAR
      this.GroupI_WidgetsData.id_Alarm = data.alarmId
      this.GroupI_WidgetsData.title_Route = data.alarm
      localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
      this.dialog.open(
        RouteCommentsComponent, {
        disableClose: true,
        width: '450px',
        height: '260px',
        data: {
          alarmId: data.alarmId,
          kpiID: this.kpiId,
          periodid: localStorage.getItem('selectedPeriodId')
        }
      });
    }
  }

  openRouteLevel(route) {
    this.router.navigate([route]);
  }

  redirectToDetailPage(data) {
    this.GroupI_WidgetsData.alarm_type_id = data.alarmTypeId
    this.GroupI_WidgetsData.id_Alarm = data.alarmId
    this.GroupI_WidgetsData.title_Route = data.alarm
    localStorage.setItem('GroupI_WidgetsData', JSON.stringify(this.GroupI_WidgetsData));
    this.router.navigate(['detail-level']);
  }


  /* this method triggers when row check box clicked in grid*/
  userCheckChanged(checked, rowIndex) {

    this.isChecked = true;
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);


    if (checked == true) {  // NOSONAR

      rowNode.setSelected(true);
      rowNode.data.checkedEditMode = true;
      rowNode.data.rowCheckBox = true;

      this.alarmID = rowNode.data.alarmId;
      this.status = rowNode.data.completed;

      // push it to the array
      const obj = { "kpiID": this.kpiId, "alarmID": this.alarmID };
      this.compOrReArr.push(obj);
    }

    else {

      this.compOrReArr.splice(this.compOrReArr.findIndex(x => x.alarmID == rowNode.data.alarmId), 1)  // NOSONAR
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
    }

    this.gridOptions.getRowStyle = function (params) {
      if (params.node.rowIndex == rowIndex) {  // NOSONAR
        //'#E4ECF0'
        const color = checked ? '#E5EEF3' : 'white';
        return { background: color };
      }
      return{}
    };

    rowNode.setData(rowNode.data);


  }

  markCompleteOrReopen() {
    if (this.isStatus != "CLOSED") { // NOSONAR
      if (!this.isChecked) {

        this.errorMessage = "Please select row(s)!";
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);

      }
      else {
        this.ngxUiLoaderService.start(this.constants.LoaderComponent);

        this.groupirouteService.markRouteAsComplete(JSON.stringify(this.compOrReArr)).subscribe(_result => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
          this.successMessage = this.constants.APIDataUpdated
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
          this.compOrReArr = []
          this.updateStatus()
          this.loadData();


        });
      }
      this.isChecked = false;
    }
  }

  numOr0(n) { return isNaN(n) ? 0 : n; }

  verificationStatus() {
    const sumRemaining = this.rowData.reduce((b, obj) => b + this.numOr0(Number(obj.remaining)), 0);
    if (sumRemaining && sumRemaining > 0) {
      this.errorMessage = "Error/Warning should either be completed or ignored.";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
      return;
    } else {
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.groupIDetailLevelService.verificationStatus(3).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") { // NOSONAR
            this.successMessage = this.constants.APIVerficationSuccess;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          } else {
            console.info(response);
            this.errorMessage = this.constants.APIVerficationError;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          }
        }, error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
          console.info("VERIFICATION STATUS _ ROUTE ", error)
        }
      )
    }
  }
  updateStatus() {

    this.groupIDetailLevelService.updateStatus(4).subscribe(
      _response => {
      }, error => {
        console.info("UPDATE STATUS _ ROUTE ", error)
      }
    )
  }
  goBack() {
    this.location.back();
  }

  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: 'Add To Queue',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') { // NOSONAR
        if (result.data == "Success") { // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }
}

